module.exports = __webpack_public_path__ + "static/media/nft-CameraOnBook.27ca7d97.png";